module.exports = __webpack_public_path__ + "img/supplierEntryGuidelines_05.8af20f57.png";